// Country code → UI language mapping
const COUNTRY_TO_LOCALE = {
  IN: 'te', // India: device locale will further refine to te/ta/ml/kn/hi
  DE: 'de', AT: 'de', CH: 'de', LI: 'de',
  FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr',
  ES: 'es', MX: 'es', AR: 'es', CO: 'es', PE: 'es', CL: 'es', VE: 'es',
  CN: 'zh', TW: 'zh', HK: 'zh', MO: 'zh', SG: 'zh',
};

const SUPPORTED = new Set(['en', 'hi', 'te', 'ta', 'ml', 'kn', 'de', 'fr', 'es', 'zh']);

export function countryToLocale(countryCode) {
  return COUNTRY_TO_LOCALE[countryCode] || null;
}

export async function detectLocaleFromIp() {
  try {
    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
    if (!res.ok) return null;
    const data = await res.json();
    return countryToLocale(data.country_code);
  } catch {
    return null;
  }
}

export function getDeviceLocale() {
  const langs = navigator.languages || [navigator.language];
  for (const lang of langs) {
    const code = lang.split('-')[0].toLowerCase();
    if (SUPPORTED.has(code)) return code;
  }
  return null;
}
